export const SESSION_CHECK_TIMEOUT_MS = 5000;
